import PropTypes from "prop-types";
import React from "react";
import getIconSVG from "./getIconSVG";

function Icon({ name }) {
  return <img alt={name} src={getIconSVG(name).src} />;
}

Icon.propTypes = {
  name: PropTypes.string,
};

Icon.defaultProps = {
  name: undefined,
};

export default Icon;
